module.exports = __webpack_public_path__ + "img/51_9.d72fcd06.png";